import { docsUrl } from "./docs"

export const types = Object.freeze([
  'network',
  'servers',
  'storage',
  'apps',
  'cloud',
  'containers',
  'monitoring',
  'others'
])

interface Integration {
  id: string
  name: string
  type: string
  doc: string
  img: string | null
}

const T: {[s: string]: string} = {}
types.forEach((name) => {
  T[name] = name
})

const all: Integration[] = []
integration('aws', 'Amazon CloudWatch', T.cloud)
integration('apache', 'Apache', T.apps)
integration('blue-coat', 'BlueCoat', T.network)
integration('ceph', 'Ceph', T.apps, 'png')
integration('cisco', 'Cisco', T.network)
integration('consul', 'Consul', T.containers)
integration('couchbase', 'Couchbase', T.apps)
integration('couchdb', 'CouchDB', T.apps, 'png', 'Couchdb')
integration('docker', 'Docker', T.containers)
integration('elasticsearch', 'Elasticsearch', T.apps, undefined, 'ElasticSearch')
integration('extreme-networks', 'Extreme Networks', T.network, 'png')
integration('gcp', 'Google Cloud Platform', T.cloud, undefined, 'Google_Cloud')
integration('haproxy', 'HAProxy', T.apps, 'png', 'HaProxy')
integration('hipchat', 'HipChat', T.monitoring, 'png')
integration('httpcheck','Http_Check',T.network, 'png')
integration('hyper-v', 'Microsoft Hyper-V', T.servers, 'png')
integration('influxdb', 'InfluxDB', T.apps)
integration('jenkins', 'Jenkins', T.apps)
integration('juniper-networks', 'Juniper Networks', T.network)
integration('kafka', 'Kafka', T.apps)
integration('kubernetes', 'Kubernetes', T.containers)
integration('linux', 'Linux', T.servers)
integration('memcached', 'Memcached', T.apps, 'png', 'MemCached')
integration('mesos', 'Mesos', T.containers, 'png')
integration('microsoft-azure', 'Microsoft Azure', T.cloud)
integration('microsoft-teams', 'Microsoft Teams', T.monitoring, 'png')
integration('ms-iis', 'Microsoft IIS', T.apps, 'png')
integration('microsoft-sql-server', 'Microsoft SQL Server', T.apps)
integration('mongodb', 'MongoDB', T.apps)
integration('mqtt','MQTT',T.others, 'png')
integration('mysql', 'MySQL', T.apps)
integration('nagios', 'Nagios', T.monitoring, 'png')
integration('network', 'Network Flows', T.network)
integration('nginx', 'NGINX', T.apps, undefined, 'Nginx')
integration('nutanix', 'Nutanix', T.storage)
integration('opsgenie','OpsGenie', T.monitoring, 'png')
integration('pagerduty','PagerDuty', T.monitoring, 'png')
integration('postgresql', 'PostgreSQL', T.apps)
integration('purestorage', 'PureStorage', T.storage)
integration('rabbitmq', 'RabbitMQ', T.apps)
integration('redis', 'Redis', T.apps)
integration('riverbed', 'Riverbed', T.network)
integration('slack', 'Slack', T.monitoring, 'png')
integration('snmp', 'SNMP', T.network)
integration('solr', 'Solr', T.apps)
integration('speedtest', 'Speedtest', T.network, 'png')
integration('tomcat', 'Tomcat', T.apps)
integration('varnish', 'Varnish', T.apps)
integration('victorops', 'VictorOps', T.monitoring, 'png')
integration('vmware', 'VMware vSphere', T.servers, undefined, 'VMware_Vsphere')
integration('microsoft-windows', 'Windows', T.servers)
integration('zookeeper', 'Zookeeper', T.apps)

export const integrations = Object.freeze(all)

function integration (id: string, name: string, type: string, ext: string | null = 'svg', doc: string = name) {
  if (!type) throw new Error(`invalid integration type for ${id}`)
  all.push({ id, name, type, doc: docsUrl('mlpacks/' + doc.replace(/ /g, '_')), img: ext && `${id}.${ext}` })
}
